import type { Context } from "@onesolution/middlewares";
import { gql } from "graphql-request";
import lodash from "lodash";
import { ALL_MONDAY_SCHEMAS } from "../TypesSchemasGQL";
import { mondayClient } from "../monday";
import { requestAndFormat } from "../utils";

function getData(
	value:
		| {
				label?: string;
				display_value?: string;
				text?: string;
				from?: string;
				to?: string;
		  }
		| string
		| boolean,
) {
	if (value === true) return "true";
	if (value === false) return "false";
	if (!value) return "";
	if (typeof value === "string") return value;
	if ("from" in value) return `${value.from}-${value.to}`;
	if ("label" in value) return value.label;
	if (Array.isArray(value)) return value.map((v) => v.label).join(",");
}

const diffKeys = (obj1: object, obj2: object) =>
	Object.keys({ ...obj1, ...obj2 }).filter((key) => {
		return getData(lodash.get(obj1, key)) !== getData(lodash.get(obj2, key));
	});

export const updateItemMutation = async (
	params: {
		itemId: string;
		boardId: string;
		columnValues: object;
	},
	context?: Context,
) => {
	const columnIds = Object.keys(params.columnValues);
	let originalItem: { id: string; name: string } | null = null;
	if (context) {
		originalItem = (
			await mondayClient.query.items({
				itemIds: [params.itemId],
				columnIds,
			})
		)?.[0];
	}

	const rep = await requestAndFormat(
		{
			defaultParams: {},
			gql: gql`
                mutation UpdateItem(
                    $itemId: ID!
                    $boardId: ID!
                    $columnValues: JSON!,
  					$columnIds: [String!]! ,
                  ) {
                    change_multiple_column_values (item_id: $itemId, board_id: $boardId, column_values: $columnValues) {
                        id
						name
						column_values(ids: $columnIds) {
							${ALL_MONDAY_SCHEMAS}

							... on BoardRelationValue {
                                display_value
                            }
						}
                    }
                }`,
			resultKey: "change_multiple_column_values",
			outType: {} as { id: string },
		},
		{ ...params, columnValues: JSON.stringify(params.columnValues), columnIds },
	);

	if (!context || !originalItem) return rep;

	try {
		const columnsDiff = diffKeys(originalItem, rep);
		await mondayClient.mutation.createUpdate({
			itemId: params.itemId,
			body: `{front} {${context.user.email}} - Edition
${columnsDiff
	.map((diffKey) => {
		return `${diffKey}: ${getData(lodash.get(originalItem, diffKey))} → ${getData(lodash.get(rep, diffKey))}`;
	})
	.join("\n")}`,
		});
	} catch (e) {
		console.error("Failed to create update for item", params, e);
	}

	return rep;
};
